import PermintaanMinyakEditor from "../../features/permintaan-minyak/components/permintaan-minyak-editor";

const PermintaanMinyakEditorPage = () => {
  return <PermintaanMinyakEditor />;
};

export default PermintaanMinyakEditorPage;
